jQuery(($) => {

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser - Keydown Focus Class
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $("body").on("keydown", function () {
        if (!$(".keyboard-in-use")[0]) {
            $(this).addClass("keyboard-in-use");
        }
    }); 

    $("body").on("mousedown", function () {
        if ($(".keyboard-in-use")[0]) {
            $(this).removeClass("keyboard-in-use");
        }
    }); 


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Leaving Site Modal
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    const link       = $("a:not(.leave-site-modal__continue-button)");
    const siteDomain = window.location.host;

    link.on("mousedown", (event) => {
        var link     = event.currentTarget,
            linkHost = link.host,
            linkURL  = link.getAttribute("href");

        if (linkHost != siteDomain) {
            event.preventDefault();

            var button = $('#leave-site-message__modal').find('.m-centered-cta-block__button');

            button.attr('href', linkURL);

            $('#leave-site-message__modal').modal('handleOpen');

        }
    });

    link.on("keydown", (event) => {
        var link     = event.currentTarget,
            linkHost = link.host,
            linkURL  = link.getAttribute("href");

        if (linkHost != siteDomain) {
            event.preventDefault();

            var button = $('#leave-site-message__modal').find('.m-centered-cta-block__button');

            button.attr('href', linkURL);

            $('#leave-site-message__modal').modal('handleOpen');

        }
    });
}); 
